import billToPayCategory from './enums/bill-to-pay-category'
import campaignStatus from './enums/campaign-status'
import examStatus from './enums/exam-status'
import examType from './enums/exam-type'
import indicationStatus from './enums/indication-status'
import itemType from './enums/item-type'
import leadStatus from './enums/lead-status'
import lessonStatus from './enums/lesson-status'
import maritalStatus from './enums/marital-status'
import paymentMethod from './enums/payment-method'
import resourceTitle from './enums/resource-title'
import supplierType from './enums/supplier-type'
import userType from './enums/user-type'
import vehicleType from './enums/vehicle-type'

export default {
  methods: {
    billToPayCategory (val) {
      return billToPayCategory.fromValue(val)
    },
    campaignStatus (val) {
      return campaignStatus.fromValue(val)
    },
    examStatus (val) {
      return examStatus.fromValue(val)
    },
    examType (val) {
      return examType.fromValue(val)
    },
    indicationStatus (val) {
      return indicationStatus.fromValue(val)
    },
    itemType (val) {
      return itemType.fromValue(val)
    },
    leadStatus (val) {
      return leadStatus.fromValue(val)
    },
    lessonStatus (val) {
      return lessonStatus.fromValue(val)
    },
    maritalStatus (val) {
      return maritalStatus.fromValue(val)
    },
    paymentMethod (val) {
      return paymentMethod.fromValue(val)
    },
    resourceTitle (resource, type) {
      return resourceTitle.fromResource(resource, type)
    },
    supplierType (val) {
      return supplierType.fromValue(val)
    },
    userType (val) {
      return userType.fromValue(val)
    },
    vehicleType (val) {
      return vehicleType.fromValue(val)
    }
  }
}
